module.exports = __webpack_public_path__ + "static/trailmap-9cef88fc71a3a073f6f2033908f757cb.png";